import {connect, MapDispatchToPropsObject} from 'react-redux';
import {
    VideoSettingsSoundOutput as Container,
    IVideoSettingsSoundOutputProps
} from './sound-output-ui';
import {selectAudioOutput} from '../../../redux/modules/video-settings';

const mapStateToProps = ({videoSettings: state}): IVideoSettingsSoundOutputProps => ({
  isSetSinkIdSupported: state.isSetSinkIdSupported,
  audioOutputDeviceId: state.audioOutput.deviceId || state.audioOutputDeviceId,
  audioOutputDevices: state.audioOutputDevices,
  audioOutputError: state.audioOutput.error,
});

const mapDispatchToProps: MapDispatchToPropsObject = {
  selectAudioOutput,
};

export const VideoSettingsSoundOutput = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Container);
